import React from 'react';
import Button from 'react-bootstrap/Button';
import { ArrowClockwise } from 'react-bootstrap-icons';
import { useTranslation } from '../i18n';

/**
 * Fallback of the root error boundary (App.tsx): whatever failed below the
 * providers (a route, the navigation, the footer, a chunk that would not load),
 * the visitor gets a message and a reload button instead of a blank page.
 */
const AppErrorFallback: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="container py-5 text-center app-error-fallback" role="alert">
      <h4>{t('errors.something_went_wrong')}</h4>
      <p className="mb-3">{t('errors.page_not_loaded')}</p>
      <Button variant="primary" onClick={() => window.location.reload()}>
        <ArrowClockwise className="me-1" />
        {t('errors.refresh_page')}
      </Button>
    </div>
  );
};

export default AppErrorFallback;
